import { render, staticRenderFns } from "./VueWebRTC.vue?vue&type=template&id=17447442&scoped=true"
import script from "./VueWebRTC.vue?vue&type=script&lang=js"
export * from "./VueWebRTC.vue?vue&type=script&lang=js"
import style0 from "./VueWebRTC.vue?vue&type=style&index=0&id=17447442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17447442",
  null
  
)

export default component.exports